const CHAVE_DOIS_FATORES_PENDENTE = "jwt_2fa_pending";
const CHAVE_LOGOUT_EXPLICITO = "jwt_logged_out";

export function definirDoisFatoresPendente(pendente: boolean): void {
	try {
		if (pendente) {
			sessionStorage.setItem(CHAVE_DOIS_FATORES_PENDENTE, "1");
			return;
		}

		sessionStorage.removeItem(CHAVE_DOIS_FATORES_PENDENTE);
	} catch {
		// ignore (storage can be unavailable)
	}
}

export function estaDoisFatoresPendente(): boolean {
	try {
		return sessionStorage.getItem(CHAVE_DOIS_FATORES_PENDENTE) === "1";
	} catch {
		return false;
	}
}

export function marcarLogoutExplicito(): void {
	try {
		localStorage.setItem(CHAVE_LOGOUT_EXPLICITO, "1");
	} catch {
		// ignore (storage can be unavailable)
	}
}

export function limparLogoutExplicito(): void {
	try {
		localStorage.removeItem(CHAVE_LOGOUT_EXPLICITO);
	} catch {
		// ignore (storage can be unavailable)
	}
}

export function foiLogoutExplicito(): boolean {
	try {
		return localStorage.getItem(CHAVE_LOGOUT_EXPLICITO) === "1";
	} catch {
		return false;
	}
}
